import { Component, OnInit, Input } from '@angular/core';

import { CommonService } from '../../services/common.service';

@Component({
  selector: 'vrm-account-info',
  template: `
    <div class="margin-10" [ngClass]="useMini ? 'margin-t-10' : 'margin-t-30'" style="opacity: 0.7" fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="center" *ngIf="!useMini">
        <div
          class="text-align-c card-avatar"
          [style.borderColor]="vrmPrimaryColor"
          [style.background]="vrmPrimaryColor"
        >
          <div class="padding-t-15 bold">{{ userInitials }}</div>
        </div>
      </div>

      <div
        class="text-align-c"
        [class.padding-t-30]="!useMini"
        [style.fontSize]="cService.isPcViewport ? fontSizeInVw : fixedFontSize"
      >
        <div>
          <span *ngIf="!useMini">Hi, &nbsp;</span> <span>{{ fullName }}</span>
        </div>
        <div *ngIf="!useMini">Last seen: {{ lastSeen | momentIeCompatibleDate: 'relativeTime' }}</div>
        <div [class.margin-t-10]="!useMini">{{ cService.userProfile.email }}</div>

        <div class="margin-t-10" fxLayout="column">
          <div class="margin-t-10 margin-b-5">
            <small class="red-text">{{ cService.readyTranslations.security.companyInUse | uppercase }}</small>
          </div>
          <mat-divider></mat-divider>

          <distributor-autocomplete-switch [isReadonly]="renderAsReadonly"></distributor-autocomplete-switch>
        </div>
      </div>

      <div class="margin-t-15 margin-b-30 bold" fxLayout="row" fxLayoutAlign="center" *ngIf="showSecurityPageButton">
        <button
          mat-stroked-button
          color="primary"
          class="sharp-corners"
          [style.fontSize]="cService.isPcViewport ? fontSizeInVw : fixedFontSize"
          (click)="cService.navigateToPage('security')"
        >
          Account & Security
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .card-avatar {
        border: 1px solid;
        color: white;

        height: 50px;
        width: 50px;
        border-radius: 50%;
      }
    `,
  ],
})
export class AccountInformationComponent implements OnInit {
  @Input() fontSizeInVw?: string = '0.75';
  @Input() showSecurityPageButton?: boolean = true;
  @Input() useMini?: boolean = false;
  @Input() canSwitchCompany: boolean = true;

  renderAsReadonly: boolean = false;

  fixedFontSize: string = '14px';
  userInitials: string;
  fullName: string;
  lastSeen: string;
  vrmPrimaryColor: string;

  constructor(public cService: CommonService) {}

  ngOnInit() {
    this.lastSeen = this.cService.userProfile.lastLoginTime;
    this.vrmPrimaryColor =
      this.cService.userProfile && this.cService.userProfile.HqColour ? '#' + this.cService.userProfile.HqColour : '';

    if (this.fontSizeInVw && !this.fontSizeInVw.trim().toLowerCase().endsWith('vw')) {
      this.fontSizeInVw += 'vw';
    }

    if (!this.canSwitchCompany) {
      this.renderAsReadonly = true;
    }

    const firstName = this.cService.userProfile.firstName;
    const lastName = this.cService.userProfile.lastName;
    this.fullName = firstName + ' ' + lastName;

    const firstInitial = firstName ? firstName.substring(0, 1).toUpperCase() : '';
    const secondInitial = lastName ? lastName.substring(0, 1).toUpperCase() : '';
    this.userInitials = firstInitial + secondInitial;
  }
}
